//import styled from "styled-components";

import { styled } from '@material-ui/core/styles';

export const HtmlContent = styled('div')({
  width: '100%',
});